import httpClient from '../httpClient';

const createUnit = async (data) => {
  return await httpClient.post(`unit/`, data);
};

const deleteUnit = async (id) => {
  return await httpClient.delete(`unit/${id}/`);
};

const updateUnit = async (id, data) => {
  return await httpClient.put(`unit/${id}/`, data);
};

const queryUnit = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/unit/?page[number]=${page}&page[size]=${pageSize}&${query}${sortBy}${searchBy}`,
  );
};

const deactivateUnit = async (id) => {
  return await httpClient.patch(`unit/${id}/deactivate/`);
};

export {
  createUnit,
  deleteUnit,
  updateUnit,
  queryUnit,
  deactivateUnit
};
